"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GovernedChannelType = void 0;
var GovernedChannelType;
(function (GovernedChannelType) {
    GovernedChannelType[GovernedChannelType["Standard"] = 0] = "Standard";
    GovernedChannelType[GovernedChannelType["Urgent"] = 1] = "Urgent";
    GovernedChannelType[GovernedChannelType["Banner"] = 2] = "Banner";
    GovernedChannelType[GovernedChannelType["TeachingMessage"] = 3] = "TeachingMessage";
    GovernedChannelType[GovernedChannelType["BusinessBar"] = 4] = "BusinessBar";
})(GovernedChannelType = exports.GovernedChannelType || (exports.GovernedChannelType = {}));
(function (GovernedChannelType) {
    function getDefault() { return GovernedChannelType.Standard; }
    GovernedChannelType.getDefault = getDefault;
})(GovernedChannelType = exports.GovernedChannelType || (exports.GovernedChannelType = {}));
